import { render, staticRenderFns } from "./RcAudit.vue?vue&type=template&id=2384629a&"
import script from "./RcAudit.vue?vue&type=script&lang=js&"
export * from "./RcAudit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports